export default () =>({
   loading:false,
   error:false,
   auctions:{},
   tenders:{},
   inquiry:{},
   supplierPrices:{}
});